import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService, AppRoutes, FundService } from '@gs-2.0/core';
import { FundDisplay, Step } from '@gs-2.0/shared';
import { TransactionService } from '../../../_core/api/transaction.service';
import Urls from '../../../_core/constants/urls';
import { Fund } from '../../../_core/models/fund';
import { buildPayload, buildSummaryData, NewCharitySummaryData } from './add-charity.model';

@Component({
  selector: 'app-add-charity',
  templateUrl: './add-charity.component.html',
  styleUrls: ['./add-charity.component.scss'],
  standalone: false,
})
export class AddCharityComponent implements OnInit {
  showInfoModal = true;
  currentStep = 1;
  loading = false;
  pageLoading = false;
  showError = false;

  currentFund: Fund;
  formData: any;
  formIsValid = false;
  summaryData: NewCharitySummaryData;

  numberFormatConfig = { decimalSymbol: '.', digitGroupingSymbol: ',', digitGrouping: '123,456,789' };

  stepperSteps: Step[] = [
    { label: 'contribute.stepper.details', number: 1 },
    { label: 'contribute.stepper.summary', number: 2 },
    { label: 'contribute.stepper.confirmation', number: 3, mobileLabel: 'contribute.stepper.confirm' },
  ];

  get activeStepIndex(): number {
    return this.currentStep - 1;
  }

  constructor(
    private router: Router,
    protected fundService: FundService,
    private transactionService: TransactionService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    const fund = this.fundService.selectedFund();
    this.currentFund = fund as unknown as Fund;
    if (!this.currentFund) {
      this.pageLoading = true;
    }
    this.fundService.loadFunds().then(() => {
      this.currentFund = this.fundService.selectedFund() as unknown as Fund;
      this.pageLoading = false;
    });
  }

  onDialogOkay(): void {
    this.showInfoModal = false;
  }

  goToSummary(): void {
    if (this.formIsValid) {
      this.summaryData = buildSummaryData(this.formData, this.currentFund);
      this.currentStep = 2;
    }
  }

  goToForm(): void {
    this.currentStep = 1;
    this.showError = false;
  }

  onSubmit(): void {
    this.loading = true;
    const payload = buildPayload(this.formData, this.currentFund, this.authService.getCurrentUserFullName());
    this.transactionService.addCharity(payload).subscribe({
      next: () => {
        this.currentStep = 3;
        this.loading = false;
      },
      error: (err) => {
        if (err?.status === 200) {
          this.currentStep = 3;
          this.loading = false;
          return;
        }
        this.loading = false;
        this.showError = true;
      },
    });
  }

  onFundChanged(fund: FundDisplay): void {
    this.fundService.setSelectedFund(fund.id);
    this.router.navigate([AppRoutes.FUND_DASHBOARD]);
  }

  goToGrant(): void {
    this.router.navigate(['/', 'fund', Urls.GRANT]);
  }
}
